<script setup lang="ts">
import { useNavigation } from "../../composables/useNavigation";

const { navigationState, toggleMobileDrawer } = useNavigation();
</script>

<template>
  <button class="nav-toggle" @click="toggleMobileDrawer">
    <span
      class="nav-toggle__icon"
      :class="[
        {
          'nav-toggle__icon--open': navigationState.mobileDrawerOpen,
        },
      ]"
    >
      <span class="nav-toggle__bar"></span>
      <span class="nav-toggle__bar"></span>
    </span>
  </button>
</template>

<style scoped lang="scss">
.nav-toggle {
  width: 2rem;
  height: 2rem;
  border: none;
  display: block;
  background: none;

  &:hover {
    .nav-toggle__bar {
      background-color: var(--color-red-hover, #ff0000);
    }
    cursor: pointer;
  }

  &__icon {
    width: 24px;
    height: 12px;
    position: relative;
    display: block;

    &--open .nav-toggle__bar:nth-child(1) {
      transform: rotate(45deg);
      top: 6px;
    }

    &--open .nav-toggle__bar:nth-child(2) {
      transform: rotate(-45deg);
      top: 6px;
    }
  }

  &__bar {
    background-color: black;
    position: absolute;
    transition: 0.3s cubic-bezier(0.8, 0.5, 0.2, 1.4);
    width: 100%;
    height: 2px;

    &:nth-child(1) {
      top: 0;
      left: 0;
    }

    &:nth-child(2) {
      bottom: 0;
      left: 0;
    }
  }
}
</style>
